import styled from '@emotion/styled';

export const GiftCertificateItem = styled.li(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    fontSize: theme.fontSizes['xs'],
    backgroundColor: theme.colors.brandOrangeUltraLight,
    padding: `${theme.space[1]} ${theme.space[3]}`,
    margin: `${theme.space[4]} 0`,
}));

export const GiftCertificateTitle = styled.h4(({ theme }) => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    fontWeight: theme.fontWeights.bold,
    textTransform: 'capitalize',
}));

export const GiftCertificateItemCancel = styled.div(() => ({
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    gap: '12px',
    padding: 0,
    background: 'none',
}));
